<!--顶部导航-->
<template>
  <div class="top-menu-list">
    <!-- 这里显示 index 小于 maxItem 的内容 -->
    <div v-for="(item,index) in currentPathArr" :href="item.path" :key="item.name"
         v-if="!item.hidden && index < maxItem">
      <!--这里设置一个长度大于了多少就下拉显示一级菜单-->
      <MenuItem :name="item.path.split('/')[1]" v-if="item.children.length>0" class="top-menu-item">
        <!-- <Icon :type="item.icon" :size="iconSize" :key="item.path"></Icon> -->
        <svg-icon :icon-class="item.icon" class="top-menu-icon" :key="item.path" />
        <span class="top-menu-title">{{item.title}}</span>
      </MenuItem>

      <MenuItem :name="item.path.split('/')[1]" v-if="item.children.length<=0" class="top-menu-item top-menu-link-item">
        <router-link tag='span' :to="item.path + '/' + item.children[0].path"
                     style="display: inline-block;height:100%;width:100%">
       <svg-icon :icon-class="item.icon" class="top-menu-link-icon" :key="item.path" />
          <!-- <Icon :type="item.icon" :size="iconSize" :key="item.path"></Icon> -->
         <span class="top-menu-title">{{item.title}}</span>
        </router-link>
      </MenuItem>
    </div>
    <Submenu name="group" v-if="maxItem !== currentPathArr.length && maxItem <= currentPathArr.length">
      <template slot="title">
        <Icon type="stats-bars"/>
        <!--其他内容-->
      </template>
      <MenuGroup title="列表">
        <div v-for="(item,index) in currentPathArr" :href="item.path" :key="item.name"
             v-if="!item.hidden && index >= maxItem">
          <!--无二级菜单-->
          <MenuItem :name="item.path.split('/')[1]" v-if="item.children.length>0">
            <Icon :type="item.icon" :size="iconSize" :key="item.path" style="width: 20px"/>
            <span class="dropdownItemIcon">{{item.title}}</span>
          </MenuItem>
          <!--有二级菜单-->
          <MenuItem :name="item.path.split('/')[1]" v-if="item.children.length<=0">
            <router-link tag='span' :to="item.path + '/' + item.children[0].path"
                         style="display: inline-block;height:100%;width:100%">
              <Icon :type="item.icon" :size="iconSize" :key="item.path" style="width: 20px"/>
              <span class="dropdownItemIcon">{{item.title}}</span>
            </router-link>
          </MenuItem>
        </div>
      </MenuGroup>
    </Submenu>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        iconSize: 14,
        //超过几个列表后显示下拉菜单 (前面有两个隐藏列，所以需要加上2)
        maxItem: 16
      }
    },
    computed: {
      currentPathArr() {
        return this.$store.state.app.routers;
        console.log(this.$store.state.app.routers)
      },
    }
  }
</script>

<style scoped>
  .top-menu-list {
    margin-left: 52px;
  }

  .top-menu-item {
    position: relative;
    padding: 0 12px 0 30px;
  }

  .top-menu-icon {
    margin-right: 4px;
    font-size: 26px;
    position: absolute;
    left: 4px;
    top: 48%;
    transform: translate(0, -49%);
  }

  .top-menu-link-item {
    padding-left: 12px;
  }

  .top-menu-link-icon {
    margin-right: 4px;
    font-size: 20px;
  }

  .top-menu-title {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/BreadcrumbNav.vue?f36efa7a